import { Subject } from "rxjs";
import { apiServiceConstants } from "../../../../constants/apiService.constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";

let themeSwitch: any = "";

let savePwdSwitch: any = "";
let setMainMenuPage = new Subject<any>();

const setSettingsMainPage = () => {
  setMainMenuPage.next(true);
};

const changeAvailabilityStatus = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/user-availability/${params.guid}/?reg_code=` + params.reg_code,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userAvilability = res as any;
      const result: any = {
        isSuccess: true,
        status: userAvilability.status,
        message: userAvilability.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getAutoInitialValues = async (): Promise<any> => {
  const params: any = {
    guid: utilService.getLoggedUserGuid(),
    reg_code: utilService.getNetwork(),
  };
  const respApiResult = await apiService
    .apiCall(
      `user/autosync-settings/?reg_code=` + params.reg_code,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const getAutoInitialValues = res as any;
      const result: any = {
        isSuccess: true,
        status: getAutoInitialValues.status,
        message: getAutoInitialValues.message,
        result: getAutoInitialValues,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const setAutoSyncStatus = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/autosync-settings/${params.guid}/?reg_code=` + params.reg_code,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const autoSyncStatus = res as any;
      const result: any = {
        isSuccess: true,
        status: autoSyncStatus.status,
        message: autoSyncStatus.message,
        result:autoSyncStatus.result
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};



const saveONEmailLinking = async (params: any): Promise<any> => {
  
  const respApiResult = await apiService
    .apiCall(
      `open-network/on-linking/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )

    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        status: userListResp.status,
        message: userListResp.message,
        result: userListResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

export const settingsService = {
  themeSwitch,
  setMainMenuPage,
  setSettingsMainPage,
  savePwdSwitch,
  changeAvailabilityStatus,
  setAutoSyncStatus,
  getAutoInitialValues,
  saveONEmailLinking
};
